import React from 'react';

import { useTranslation } from 'react-i18next';

import { ShopifyBurstPageTitle } from 'lane-shared/types/integrations/ShopifyBurst';

import BurstCustomPageRenderer from 'components/integrations/ShopifyBurst/pages/BurstCustomPageRenderer';

import { BurstCreatePageProps } from '../../components/BurstCreateFlow';

export default function BurstSpecialRequest({
  wizardState,
  content,
  onDataUpdated,
  goToNextStep,
  goToPrevStep,
  ...rest
}: BurstCreatePageProps) {
  const { t } = useTranslation();

  // we convert v2 custom page values into v1 format fields for backward compatibility
  // with mobile app versions that only work with v1 format values
  function handleDataUpdated(data: any) {
    onDataUpdated({
      ...data,
      specialRequest: data.specialRequestInteraction?.data?.specialRequest,
    });
  }

  return (
    <BurstCustomPageRenderer
      interactionKey="specialRequestInteraction"
      title={t(ShopifyBurstPageTitle.BurstSpecialRequest)}
      wizardState={wizardState}
      content={content}
      goToPrevStep={goToPrevStep}
      goToNextStep={goToNextStep}
      onDataUpdated={handleDataUpdated}
      contentKey="specialRequestContent"
      {...rest}
    />
  );
}
